import {Box, Stack} from '@mantine/core';
import React from 'react';

import {SCRATCH_PLATE_VIEWER_MIN_HEIGHT} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateViewConstants';
import {ContentsLayerScratchPlateViewer} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateViewer';
import useFilledScratchPlateData from 'notebook/integrations/plate-maps/scratch-plates/useFilledScratchPlateData';
import Pane from 'ui-library/pane/Pane';

export interface ScratchPlatePreviewItem {
  id: string;
  name: string | null;
}

interface ScratchPlateOutputPreviewProps {
  scratchPlates: Array<ScratchPlatePreviewItem>;
  title: string;
}

function ScratchPlatePreviewContent({scratchPlateId}: {scratchPlateId: string}): JSX.Element {
  const {result} = useFilledScratchPlateData(scratchPlateId);
  return <ContentsLayerScratchPlateViewer result={result} />;
}

/** Render one document plate group with fully hydrated contents-layer previews. */
export default function ScratchPlateOutputPreview({
  scratchPlates,
  title,
}: ScratchPlateOutputPreviewProps): JSX.Element {
  return (
    <Pane title={title}>
      <Stack spacing="md" p="md">
        {scratchPlates.map((scratchPlate, occurrenceIndex) => (
          // Floor each plate's height so the viewer renders at full size instead of collapsing when
          // the surrounding container is a scroll region.
          <Box key={`${scratchPlate.id}-${occurrenceIndex}`} miw={0} mih={SCRATCH_PLATE_VIEWER_MIN_HEIGHT}>
            <ScratchPlatePreviewContent scratchPlateId={scratchPlate.id} />
          </Box>
        ))}
      </Stack>
    </Pane>
  );
}
